import { createApp } from "petite-vue";

export function initTryPage() {
  createApp({
    $delimiters: ["${", "}"],
    agreeLicence: false,
    agreeTerms: false,
  }).mount("#js-try-page");
}
